<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocArgCtaRdvPedagogieMatchers'
});
</script>
<template>
  <ka-container
    code="bloc-arg-cta-rdv-pedagogie-matchers"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocArgCtaRdvPedagogieMatchersComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c8')
const component = blocArgCtaRdvPedagogieMatchersComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  expert1?: Nullable<string | File>
  expert2?: Nullable<string | File>
  expert3?: Nullable<string | File>
  titreExperts?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  expert1: 'https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg',
  expert2: 'https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg',
  expert3: 'https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg',
  titreExperts: 'Nos experts en ',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:expert1',
  'update:expert2',
  'update:expert3',
  'update:titreExperts'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    expert1: true,
    expert2: true,
    expert3: true,
    titreExperts: true
  }
})
</script>
